export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_80a769d9-fc8a-4d76-8271-2ba459e365e2/artifacts/am42j9gt_Arquivos%20Logos_sem%20fundo-07%20%281%29.png";

const Logo = ({ size = 44, withText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="unigr-logo">
      <img
        src={LOGO_URL}
        alt="UniGR"
        style={{ height: size, width: "auto" }}
        className="object-contain select-none"
        draggable={false}
      />
      {withText && (
        <div className="hidden sm:block leading-tight">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#6B8DB3]">
            Diagnóstico
          </div>
          <div className="text-sm font-semibold text-white tracking-tight">
            Maturidade em Gestão de Frota
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
